var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalityCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73958 4.23901L5.95818 5.22878C5.854 5.66289 5.64562 6.56236 5.64562 6.68739C5.64562 6.84366 5.33307 8.66692 5.28097 8.87529C5.22888 9.08366 5.02051 10.9069 5.02051 11.1674V13.3553C5.02051 13.6158 5.28097 13.6678 5.64562 13.8762C6.01028 14.0846 6.73958 13.8762 7.00004 13.8762H8.25028C8.33362 13.8762 9.46578 13.9804 10.0214 14.0325C10.4555 14.102 11.3863 14.2617 11.6363 14.3451C11.9489 14.4492 12.5219 14.6576 12.9907 14.866C13.4596 15.0744 14.241 15.2306 14.5014 15.2306H16.1684C16.6373 15.2306 17.2624 14.9181 17.9396 14.866C18.6168 14.8139 18.4605 14.1367 18.4605 14.0325V12.1051C18.4605 11.3758 18.3563 10.7506 18.3563 9.50041V6.89576V5.38506C17.7659 5.33297 16.5539 5.26004 16.4289 5.38506C16.3039 5.51008 15.196 5.54134 14.6577 5.54134L13.6159 5.0725C13.3207 4.93359 12.6886 4.64534 12.5219 4.60366C12.3552 4.56199 12.001 4.3432 11.8447 4.23901H8.87539H6.73958Z",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46667 20.952V5.02002",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5331 14.2509V4.89893",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 14.2327C5.4668 14.2327 6.28346 13.5542 8.73346 13.5542C11.1835 13.5542 12.8168 15.1661 15.2668 15.1661C17.7168 15.1661 18.5335 14.2542 18.5335 14.2542",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 4.83544C5.4668 4.83544 6.28346 3.96558 8.73346 3.96558C11.1835 3.96558 12.8168 5.57744 15.2668 5.57744C17.7168 5.57744 18.5335 4.89891 18.5335 4.89891",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalityCheck);
export default __webpack_public_path__ + "static/media/nationality_check.c3b4ddd64c73bc008b789a0b63659d67.svg";
export { ForwardRef as ReactComponent };